import React from "react";
import { Button } from "../ui/button";
import { CheckCircle2, AlertTriangle } from "lucide-react";

export default function PhaseSummary({ data, onBack, onFinalize, loading }) {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-xl font-semibold text-white mb-2">Resumen Final</h2>
        <p className="text-slate-400 text-sm">Revisa toda la información antes de crear el cliente</p>
      </div>

      <div className="max-w-2xl mx-auto space-y-4">
        {/* Tipo de Persona */}
        <div className="bg-slate-800/50 rounded-lg p-4">
          <h3 className="text-white font-medium text-sm mb-2 flex items-center gap-2">
            <CheckCircle2 size={16} className="text-teal-400" />
            Tipo de Persona
          </h3>
          <p className="text-slate-300">{data.person_type === "fisica" ? "Persona Física" : "Persona Moral"}</p>
        </div>

        {/* Datos Personales */}
        <div className="bg-slate-800/50 rounded-lg p-4">
          <h3 className="text-white font-medium text-sm mb-2 flex items-center gap-2">
            <CheckCircle2 size={16} className="text-teal-400" />
            Datos Personales
          </h3>
          <div className="text-slate-300 text-sm space-y-1">
            <p><strong>Nombre:</strong> {data.first_name} {data.paternal_surname} {data.maternal_surname}</p>
            <p><strong>Fecha de Nacimiento:</strong> {data.birth_date}</p>
            <p><strong>CURP:</strong> {data.curp} {data.curp_validated && <span className="text-teal-400">✅ Validada</span>}</p>
            {data.rfc && <p><strong>RFC:</strong> {data.rfc}</p>}
          </div>
        </div>

        {/* Domicilio */}
        <div className="bg-slate-800/50 rounded-lg p-4">
          <h3 className="text-white font-medium text-sm mb-2 flex items-center gap-2">
            <CheckCircle2 size={16} className="text-teal-400" />
            Domicilio
          </h3>
          <p className="text-slate-300 text-sm">
            {data.address_matches_ine ? (
              "Domicilio del INE (actual)"
            ) : (
              `${data.street} ${data.ext_number}, ${data.neighborhood}, ${data.municipality}, ${data.state}`
            )}
          </p>
        </div>

        {/* Contacto */}
        <div className="bg-slate-800/50 rounded-lg p-4">
          <h3 className="text-white font-medium text-sm mb-2 flex items-center gap-2">
            <CheckCircle2 size={16} className="text-teal-400" />
            Contacto
          </h3>
          <div className="text-slate-300 text-sm space-y-1">
            <p><strong>Email:</strong> {data.email}</p>
            {data.phone && <p><strong>Teléfono:</strong> {data.phone}</p>}
            {data.mobile && <p><strong>Móvil:</strong> {data.mobile}</p>}
          </div>
        </div>

        {/* Info */}
        {data.curp && (
          <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-3">
            <p className="text-slate-400 text-sm">
              La constancia CURP se obtendrá automáticamente al crear el cliente.
            </p>
          </div>
        )}
      </div>

      <div className="flex justify-between mt-8">
        <Button onClick={onBack} variant="outline" className="border-slate-700">
          ← Atrás
        </Button>
        <Button
          onClick={onFinalize}
          disabled={loading}
          className="bg-teal-600 hover:bg-teal-500 text-white"
        >
          {loading ? "Creando..." : "✅ Crear Cliente"}
        </Button>
      </div>
    </div>
  );
}
